export function scrollToBottom() {
  setTimeout(() => {
    const chatContainer = document.querySelector('.slds-chat');
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }, 100);
}
